import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgComputerJusAi(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.956 34.825A6.325 6.325 0 0 1 22.28 28.5h76.91a6.324 6.324 0 0 1 6.324 6.325v50.71h-89.56v-50.71Z"
        fill="#78B441"
      />
      <path
        d="M21.224 36.112a2.372 2.372 0 0 1 2.372-2.372h73.863a2.372 2.372 0 0 1 2.372 2.372v41.672a2.372 2.372 0 0 1-2.372 2.372H23.596a2.372 2.372 0 0 1-2.372-2.372V36.112Z"
        fill="#fff"
      />
      <path
        d="M49.273 63.367V62.21c.586.41 1.216.615 1.892.615.675 0 1.197-.171 1.505-.514.308-.343.462-.905.462-1.685v-7.064h1.11v7.154c0 .625-.087 1.16-.262 1.602-.175.443-.414.772-.717.987a3.03 3.03 0 0 1-.931.459c-.318.09-.66.135-1.025.135a4.03 4.03 0 0 1-2.035-.533ZM56.461 60.551v-4.444h1.111V60.6c0 .78.17 1.35.51 1.712.34.362.872.543 1.596.543.725 0 1.244-.18 1.589-.543.345-.362.517-.932.517-1.712v-4.494h1.111v4.444c0 1.066-.28 1.891-.84 2.474-.56.583-1.353.875-2.377.875-1.024 0-1.816-.292-2.377-.875-.56-.583-.84-1.407-.84-2.474ZM64.196 58.19c0-.613.224-1.136.672-1.569.448-.433 1.132-.65 2.053-.65.656 0 1.311.156 1.967.467v1.104a3.535 3.535 0 0 0-1.847-.527c-1.156 0-1.734.391-1.734 1.174 0 .266.14.48.42.644a4.2 4.2 0 0 0 1.03.407c.405.108.81.237 1.216.387.405.151.75.405 1.032.764.282.36.424.817.424 1.374 0 .667-.25 1.19-.747 1.568-.498.378-1.187.567-2.068.567-.88 0-1.624-.192-2.32-.578V62.15c.736.451 1.494.677 2.275.677 1.166 0 1.75-.354 1.75-1.061 0-.382-.14-.68-.421-.896a2.885 2.885 0 0 0-1.029-.486c-.405-.107-.81-.225-1.216-.353a2.353 2.353 0 0 1-1.032-.648c-.283-.303-.424-.701-.424-1.193h-.001ZM73.218 63.66V53.564h1.397V63.66h-1.397ZM76.3 63.66l4.03-10.097h1.374l4.014 10.098h-1.515l-1.087-2.846h-4.213l-1.087 2.846H76.3Zm3.105-4.146h3.208l-1.604-4.192-1.604 4.191ZM42.153 56.846c.32 0 .605.157.783.398l.07.11.004.008 2.735 5.19h.001c.333.638-.117 1.426-.857 1.426H39.2a.976.976 0 0 1-.852-.508l-.005-.008.443-.233-.442.232-2.733-5.19c-.333-.636.116-1.422.854-1.424v-.001h5.687Zm-2.932 6.132h5.618l-2.705-5.132h-5.615l2.702 5.132Z"
        fill="#007A5F"
      />
      <path
        d="M47.083 49.5a.97.97 0 0 1 .953 1.134h.001l-2.12 12.533a.968.968 0 0 1-.955.81h-5.731a.97.97 0 0 1-.953-1.137l2.184-12.535v-.002a.97.97 0 0 1 .953-.803h5.668ZM39.27 62.977h5.666l2.11-12.477h-5.602l-2.174 12.477Z"
        fill="#007A5F"
      />
      <path
        d="M114 85.81a6.325 6.325 0 0 1-6.325 6.324h-94.35A6.325 6.325 0 0 1 7 85.81v-.274h107v.274Z"
        fill="#78B441"
      />
      <path
        d="M44.238 85.535h32.996v.928a2.372 2.372 0 0 1-2.372 2.372H46.61a2.372 2.372 0 0 1-2.372-2.372v-.928Z"
        fill="#599F40"
      />
      <path d="M109.287 84.736a.8.8 0 0 1 0 1.6H7.471a.8.8 0 1 1 0-1.6h101.816Z" fill="#0F172A" />
      <path d="M54.913 28.5h11.23v5.24h-11.23V28.5Z" fill="#599F40" />
      <path
        d="M62.233 31.411a1.414 1.414 0 1 1-2.828 0 1.414 1.414 0 0 1 2.828 0Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgComputerJusAi)
